import { call, put, takeLatest } from 'redux-saga/effects';

import { actions } from '@tvguide/store/actions/requests';
import { addProgramsToChannels } from '@store/actions/programs';
import { setUXProp, setLoad } from '@store/actions/ux';
import API from '@api';

function* fetchTvGuide(action) {
  try {
    yield put(
      setUXProp({
        isLoadingTvguide: true,
      }),
    );
    const chanWithPrograms = yield call(
      API.getTvGuide.bind(API),
      action.nid,
      action.start,
    );
    yield put(addProgramsToChannels(chanWithPrograms));
    yield put(
      setLoad({
        programs: true,
      }),
    );
    yield put(
      setUXProp({
        isLoadingTvguide: false,
      }),
    );
  } catch (e) {
    console.error(e);
    yield put(
      setUXProp({
        isLoadingTvguide: false,
      }),
    );
  }
}

function* tvguideSaga() {
  yield takeLatest(actions.tvguide, fetchTvGuide);
}

export default tvguideSaga;
